import { memo, useCallback, useEffect, useState, VFC } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import {
  Box,
  Wrap,
  WrapItem
} from "@chakra-ui/react";

import { MenuCard } from "../../organisms/user/MenuCard";

import { useLoginUser } from "../../../hooks/useLoginUser";
import { HeaderLayout } from "../../templates/HeaderLayout";

export const Home: VFC = memo(() => {
  const loginUser = useLoginUser();

  const navigate = useNavigate();
  const onClickRegistTenant = useCallback(() => navigate("/home/regist"), []);
  const onClickTenants = useCallback(() => navigate("/home/tenants"), []);
  const onClickUsers = useCallback(() => navigate("/home/users"), []);
  const onClickGroups = useCallback(() => navigate("/home/groups"), []);

  var onClickEditTenant = ()=>{navigate("/home/tenant/" + (loginUser ? loginUser.loginUser?.tenant : ""));};
  useEffect(()=>{
    onClickEditTenant = ()=>{navigate("/home/tenant/" + (loginUser ? loginUser.loginUser?.tenant : ""));};
  },[loginUser]);

    return (
    <>
      <HeaderLayout>{loginUser && <Outlet />}
        {
          useLocation().pathname === "/home" ? (
            <>
              {loginUser.loginUser?.isAdmin ? 
              (
                <>
                  <Box pl="5" my="2">
                  メニューを選択してください。
                  </Box>
                  <Wrap p={{ base: 4, md: 10 }}>
                    <WrapItem mx="auto">
                      <MenuCard
                      menuTitle={"ユーザー管理"}
                      description={"ユーザーを追加・更新・削除します。"}
                      enabled={true}
                      onClick={onClickUsers}
                      />
                    </WrapItem>
                    <WrapItem mx="auto">
                      <MenuCard
                      menuTitle={"グループ管理"}
                      description={"グループを追加・更新・削除します。"}
                      enabled={true}
                      onClick={onClickGroups}
                      />
                    </WrapItem>
                    <WrapItem mx="auto">
                      <MenuCard
                      menuTitle={"センサー管理"}
                      description={"センサーを追加・更新・削除します。"}
                      enabled={true}
                      onClick={onClickEditTenant}
                      />
                    </WrapItem>
                    {loginUser.loginUser.isAccountAdmin ? (
                      <>
                        <WrapItem mx="auto">
                        <MenuCard
                        menuTitle={"市町村管理"}
                        description={"市町村を更新・削除します。"}
                        enabled={true}
                        onClick={onClickTenants}
                        />
                        </WrapItem>
                        <WrapItem mx="auto">
                          <MenuCard
                          menuTitle={"市町村追加"}
                          description={"市町村を追加します。"}
                          enabled={true}
                          onClick={onClickRegistTenant}
                          />
                        </WrapItem>
                      </>
                    ):(
                      <></>
                    )}
                  </Wrap>
                </>
              ) : 
              (
                <Box pl="5">
                一般ユーザーはメニューを使用できません。
                </Box>
              )}
            </>
          ):(
            <></>
          )
        }
      </HeaderLayout>
    </>
  );
});
